module.exports = __webpack_public_path__ + "static/media/Sign.740ac4d4.png";